import HomeIcon from '#assets/icon/ic_home_icon';
import CommunityIcon from '#assets/icon/navigation/CommunityIcon';
import ConsumerIcon from '#assets/icon/navigation/ConsumerIcon';
import ProfileIcon from '#assets/icon/navigation/ProfileIcon';
import ScheduleIcon from '#assets/icon/navigation/ScheduleIcon';

export const NAVIGATION_LIST = [
  {
    name: '홈',
    route: '/home',
    icon: HomeIcon
  },
  {
    name: '트뮤니티',
    route: '/trainer-community',
    icon: ScheduleIcon
  },
  {
    name: '운동톡',
    route: '/community/qna',
    icon: CommunityIcon,
    incldues: '/community'
  },
  {
    name: '관리',
    route: '/manage',
    icon: ConsumerIcon
  },
  {
    name: '프로필',
    route: '/profile',
    icon: ProfileIcon
  }
];
